import { useEffect, useState } from 'react';

/** Updates every `interval` ms with the current time in the given tz.
 *  The zone label (e.g. AEST / AEDT) is derived so it tracks daylight saving. */
export function useClock(tz = 'Australia/Sydney', interval = 30000) {
  const [now, setNow] = useState(() => fmt(tz));
  useEffect(() => {
    const id = setInterval(() => setNow(fmt(tz)), interval);
    return () => clearInterval(id);
  }, [tz, interval]);
  return now;
}

function tzLabel(tz = 'Australia/Sydney') {
  try {
    const parts = new Intl.DateTimeFormat('en-AU', { timeZone: tz, timeZoneName: 'short' }).formatToParts(new Date());
    return parts.find((p) => p.type === 'timeZoneName')?.value ?? '';
  } catch {
    return '';
  }
}

function fmt(tz) {
  try {
    const opts = { hour: '2-digit', minute: '2-digit', timeZone: tz, hour12: false };
    return `${new Date().toLocaleTimeString('en-AU', opts)} ${tzLabel(tz)}`.trim();
  } catch {
    return '—';
  }
}
